export enum StatusCarrinhoCompra {
  Aberto = 'Aberto',
  Finalizado = 'Finalizado',
  Cancelado = 'Cancelado'
}
